
import actionTypes from './actionsTypes';

const initialState = {
    openModalAprovar: false,
    openModalAnexarNotaFiscal:false,
};

const actions = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MODAL_APROVAR_EXTRATO_OPEN:
            return {
                ...state,
                openModalAprovar: true,
            };
        case actionTypes.MODAL_APROVAR_EXTRATO_CLOSE:
            return {
                ...state,
                openModalAprovar: false,
            };
        case actionTypes.MODAL_ANEXAR_NOTA_FISCAL_OPEN:
            return {
                ...state,
                openModalAnexarNotaFiscal: true,
            };
        case actionTypes.MODAL_ANEXAR_NOTA_FISCAL_CLOSE:
            return {
                ...state,
                openModalAnexarNotaFiscal: false,
            };
        default:
            return state;
    }
};

export default actions;
